import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "@/lib/axios";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings, Sliders } from "lucide-react";

// Şu an kullanılmıyor ancak ileride ihtiyaç olabilir
/*
interface VoiceSettings {
  stability: number;
}
*/

const VoiceSettingsConfig = () => {
  const [activeTab, setActiveTab] = useState("voice-modes");

  // Ses ayarlarını getirme
  const { isLoading } = useQuery({
    queryKey: ["voice-mode-settings"],
    queryFn: async () => {
      const { data } = await axios.get("/api/settings/voice-modes");
      return data;
    },
  });

  // Ayarları güncelleme (şu an kullanılmasa da gelecekte gerekeceğinden yorum olarak bırakalım)
  /*
  const updateVoiceModeSettings = useMutation({
    mutationFn: async (settings: VoiceModeSetting[]) => {
      const { data } = await axios.put("/api/settings/voice-modes", { settings });
      return data;
    },
    onSuccess: () => {
      toast({
        title: "Ayarlar güncellendi",
        description: "Ses modu ayarları başarıyla kaydedildi.",
      });
      queryClient.invalidateQueries({ queryKey: ["voice-mode-settings"] });
    },
    onError: () => {
      toast({
        title: "Hata",
        description: "Ayarlar kaydedilirken bir hata oluştu.",
        variant: "destructive",
      });
    },
  });
  */

  return (
    <div className="container mx-auto py-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold">Ses Ayarları</h1>
          <p className="text-muted-foreground">
            AI anons sistemi için ses ayarlarını ve modlarını yapılandırın
          </p>
        </div>
      </div>

      <Tabs defaultValue="voice-modes" value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="voice-modes">
            <Sliders className="w-4 h-4 mr-2" />
            Ses Tonu Modları
          </TabsTrigger>
          <TabsTrigger value="default-settings">
            <Settings className="w-4 h-4 mr-2" />
            Varsayılan Ses Ayarları
          </TabsTrigger>
        </TabsList>

        {/* İleriki kısımlarda dolduracağımız içerik buraya gelecek */}
        <TabsContent value="voice-modes">
          <Card>
            <CardHeader>
              <CardTitle>Ses Tonu Modları</CardTitle>
              <CardDescription>
                Farklı duygu ve ton seçenekleri için ses modu ayarlarını yapılandırın
              </CardDescription>
            </CardHeader>
            <CardContent>
              {isLoading ? (
                <div className="space-y-4">
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-10 w-full" />
                </div>
              ) : (
                <p>İçerik yakında eklenecek</p>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="default-settings">
          <Card>
            <CardHeader>
              <CardTitle>Varsayılan Ses Ayarları</CardTitle>
              <CardDescription>
                Yeni anons oluşturulduğunda kullanılacak varsayılan ses ayarlarını belirleyin
              </CardDescription>
            </CardHeader>
            <CardContent>
              {isLoading ? (
                <div className="space-y-4">
                  <Skeleton className="h-10 w-full" />
                  <Skeleton className="h-10 w-full" />
                </div>
              ) : (
                <p>İçerik yakında eklenecek</p>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default VoiceSettingsConfig;
